@if (itemsWithJsonData.length) {
    <app-table
        [items]="itemsWithJsonData"
        [columns]="columns"
        translatePrefix="form.esas."
        [hideCheckboxes]="true"
        [resource]="resource"
        (detailCallback)="detail($event)"
        (deleteCallbackWithEvent)="delete($event)"
    >
        <ng-template pTemplate="printHeader"></ng-template>
        <ng-template pTemplate="print" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-print"
                (clickEvent)="print(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="copyHeader"></ng-template>
        <ng-template pTemplate="copy" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-copy"
                (clickEvent)="copy(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="pain" let-item="item">
            {{ item.data.pain === -1 ? ('form.esas.unknownValue' | translate) : item.data.pain }}
        </ng-template>

        <ng-template pTemplate="fatigue" let-item="item">
            {{ item.data.fatigue === -1 ? ('form.esas.unknownValue' | translate) : item.data.fatigue }}
        </ng-template>

        <ng-template pTemplate="sleepiness" let-item="item">
            {{ item.data.sleepiness === -1 ? ('form.esas.unknownValue' | translate) : item.data.sleepiness }}
        </ng-template>

        <ng-template pTemplate="nausea" let-item="item">
            {{ item.data.nausea === -1 ? ('form.esas.unknownValue' | translate) : item.data.nausea }}
        </ng-template>

        <ng-template pTemplate="distaste" let-item="item">
            {{ item.data.distaste === -1 ? ('form.esas.unknownValue' | translate) : item.data.distaste }}
        </ng-template>

        <ng-template pTemplate="shortnessOfBreath" let-item="item">
            {{ item.data.shortnessOfBreath === -1 ? ('form.esas.unknownValue' | translate) : item.data.shortnessOfBreath }}
        </ng-template>

        <ng-template pTemplate="depression" let-item="item">
            {{ item.data.depression === -1 ? ('form.esas.unknownValue' | translate) : item.data.depression }}
        </ng-template>

        <ng-template pTemplate="anxiety" let-item="item">
            {{ item.data.anxiety === -1 ? ('form.esas.unknownValue' | translate) : item.data.anxiety }}
        </ng-template>

        <ng-template pTemplate="wellBeing" let-item="item">
            {{ item.data.wellBeing === -1 ? ('form.esas.unknownValue' | translate) : item.data.wellBeing }}
        </ng-template>

        <ng-template pTemplate="other" let-item="item">
            {{ item.data.other === -1 ? ('form.esas.unknownValue' | translate) : item.data.other }}
        </ng-template>

    </app-table>
}
